var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 6.66663V13.3333H12.0002C13.1047 13.3333 14.0002 12.4379 14.0002 11.3333V8.66663C14.0002 7.56206 13.1047 6.66663 12.0002 6.66663H7.3335ZM10.0002 7.99996H8.66683V12H12.0002C12.3684 12 12.6668 11.7015 12.6668 11.3333V8.66663C12.6668 8.29844 12.3684 7.99996 12.0002 7.99996H11.3335V8.66663C11.3335 9.03482 11.035 9.33329 10.6668 9.33329C10.2986 9.33329 10.0002 9.03482 10.0002 8.66663V7.99996Z",
    fill: "#485D7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.66663C2.89543 6.66663 2 7.56206 2 8.66663V11.3333C2 12.4379 2.89543 13.3333 4 13.3333H8.66668V6.66663H4ZM4.66667 7.99996H4C3.63181 7.99996 3.33334 8.29844 3.33334 8.66663V11.3333C3.33334 11.7015 3.63181 12 4 12H7.33334V7.99996H6.00001V8.66663C6.00001 9.03482 5.70153 9.33329 5.33334 9.33329C4.96515 9.33329 4.66667 9.03482 4.66667 8.66663V7.99996Z",
    fill: "#485D7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66651 1.33337C5.56194 1.33337 4.6665 2.2288 4.6665 3.33337V8.00004H11.3332V3.33337C11.3332 2.2288 10.4378 1.33337 9.33318 1.33337H6.66651ZM7.33318 2.66671H6.66651C6.29832 2.66671 5.99984 2.96518 5.99984 3.33337V6.66671H9.99985V3.33337C9.99985 2.96518 9.70137 2.66671 9.33318 2.66671H8.66651V3.33337C8.66651 3.70156 8.36803 4.00004 7.99984 4.00004C7.63165 4.00004 7.33318 3.70156 7.33318 3.33337V2.66671Z",
    fill: "#485D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.b57cf8a0.svg";
export { ForwardRef as ReactComponent };